import React from 'react';

function Footer() {
  return (
    <footer style={{background: '#fff', color: '#222', textAlign: 'center', padding: '16px 0 8px 0', position: 'fixed', left: 0, bottom: 0, width: '100%', zIndex: 100, boxShadow: '0 -2px 8px rgba(0,0,0,0.04)'}}>
      <div style={{maxWidth: '1200px', margin: '0 auto'}}>
        <p style={{margin: 0}}>&copy; 2026 K-R-O Trust Portal™. All rights reserved. Patent (Pending) In Use.</p>
        <p style={{margin: '2px 0 0 0', fontSize: '0.8rem', color: '#555'}}>U.S.-rooted operations</p>
      </div>
    </footer>
  );
}

export default Footer;
